import { DefaultQueryClientProvider } from '@opallabs/higgs'
import { ContentVersionHistoryDrawer } from './ContentVersionHistoryDrawer'

type ConnectedContentVersionHistoryDrawerProps = React.ComponentProps<
  typeof ContentVersionHistoryDrawer
>

/**
 * Legacy mount point: the drawer is rendered from the Backbone post shroud, where
 * no QueryClientProvider exists in the tree.
 */
export const ConnectedContentVersionHistoryDrawer: React.VFC<
  ConnectedContentVersionHistoryDrawerProps
> = (props) => (
  <DefaultQueryClientProvider>
    <ContentVersionHistoryDrawer {...props} />
  </DefaultQueryClientProvider>
)
